import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-back2",
  "use": "icon-back2-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-back2\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h16v16H0z\" /><path fill=\"currentColor\" fill-rule=\"nonzero\" d=\"M11.248 3.061 6.121 8.186l5.127 5.128-1.061 1.06L4 8.187 10.187 2z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol